import { useState, useEffect } from "react";
import { API } from "../constant";
import { Link } from "react-router-dom";
import { getToken } from "../helpers";
import useFetchAPI from "../Components/Hooks/useFetchAPI";
import siteLogo from "../Media/logo-icon.svg";

const Welcome = () =>{

    const [appInfoData, setAppInfoData] = useState({});

    const appInfo = useFetchAPI(`${API}/app-information?populate=*`);
    
    useEffect(()=>{
        if (appInfo && appInfo.data) {
            setAppInfoData({
                    logo: appInfo.data.attributes.app_logo.data.attributes.url,        
                });
        }
    },[appInfo]);

    return(
        <div className="common-bg">
            <div className="container">
                <div className="content-wrap">
                    <div className="welcome">
                        <div className="logo">
                            
                            <img src={siteLogo} alt="logo"/>
                        </div>
                        <div className="heading">
                            <h2>Welcome To CopeAhead</h2>
                        </div>
                        <div className="description">
                            <p>To feel yourself comfortable and heal yourself, The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters</p>
                        </div>
                        <div className="btn">
                            <Link to={getToken() ? "/ChooseOption" : "/Login"}><button className="theme-btn">Let's Get Started</button></Link>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
}
export default Welcome;